import React from 'react';
import PropTypes from 'prop-types';

import { pickBy } from 'lodash';
import cx from 'classnames';
import displayName from 'component-lib/displayName';
import RetinaImage from '../../RetinaImage';

export default class ActionButton extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        onHover: PropTypes.func,
        image: PropTypes.any,
        label: PropTypes.string,
        styles: PropTypes.object,
        extraClassName: PropTypes.string,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        onClick: () => {},
        onHover: () => {},
        image: null,
        label: '',
        styles: {},
        extraClassName: '',
        disabled: false,
    };

    setRef = (button) => {
        this.DOMNode = button;
    };

    render() {
        const {
            onClick,
            onHover,
            image,
            label,
            styles,
            extraClassName,
        } = this.props;

        const buttonProps = {
            className: cx(styles.button, extraClassName),
            ref: this.setRef,
            disabled: this.props.disabled,
            ...pickBy(this.props, (v, k) => k.indexOf('data-') === 0),
        };

        if (onClick) { buttonProps.onClick = onClick; }
        if (onHover) {
            buttonProps.onMouseOver = onHover;
            buttonProps.onMouseOut = onHover;
        }

        return (
            <button {...buttonProps}>
                <span className={styles.image}>
                    <RetinaImage image={image} />
                </span>
                <span className={styles.label}>
                    {label}
                </span>
            </button>
        );
    }
}

ActionButton.generate = (defProps) => {
    const actionButton = class extends ActionButton {
        static defaultProps = defProps;
    };

    actionButton.displayName = displayName(defProps.label);

    return actionButton;
};
